import './styles.css';
import Header from './components/Header.js';
import PageBackdrop from './Registercomponents/PageBackdrop.jsx';
import HeroSection from './Registercomponents/HeroSection.jsx';
import RegistrationForm from './Registercomponents/RegistrationForm.jsx';

export default function RegisterInterestPage() {
  return (
    <>
      <Header showFullLogo={true} />
      <PageBackdrop />
      <div className="page">
        <HeroSection />
        <main className="page__form">
          <RegistrationForm />
        </main>
      </div>
    </>
  );
}
